// extracted by mini-css-extract-plugin
export var marginNegative = "_5u-5 _5u-3 _5u-1";
export var marginPositive = "_5u-4 _5u-3 _5u-1";
export var modalContent = "_5u-6";
export var samplesTable = "_5u-8";
export var samplesTableContainer = "_5u-7";
export var statBox = "_5u-a";
export var tableCell = "_5u-1";
export var tableCellCenter = "_5u-2 _5u-1";
export var tableCellRight = "_5u-3 _5u-1";
export var tableHeader = "_5u-0";
export var trackingNumber = "_5u-9";